import { ImagePlus, Loader2, X } from "lucide-react";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const GalleryField = ({ label, value = [], onChange, fromEres = 0, inherited = [], testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    setBusy(true);
    const urls = [];
    try {
      for (const f of files.slice(0, 10 - value.length)) {
        const fd = new FormData();
        fd.append("file", f);
        urls.push((await api.post("/admin/upload", fd)).data.url);
      }
      toast.success(`${urls.length} photo(s) added`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      if (urls.length) onChange([...new Set([...value, ...urls])]);
      setBusy(false);
      ref.current.value = "";
    }
  };
  return (
    <div className="field" data-testid={testid}>
      <span className="field-label">{label}</span>
      <p className="mb-2 text-xs text-ink/50">Guests swipe through these after the main photo{fromEres ? `, then ${fromEres} photo(s) from eRes` : ""}.</p>
      {!value.length && inherited.length > 0 && (
        <div className="mb-3" data-testid={`${testid}-owner`}>
          <p className="mb-1 text-xs text-ink/60">Showing the verified owner's {inherited.length} photo(s) until you add your own:</p>
          <div className="flex flex-wrap gap-2">{inherited.map((u, i) => <img key={`${u}-${i}`} src={u} alt="" className="h-14 w-20 rounded-lg object-cover opacity-50" />)}</div>
        </div>
      )}
      <div className="flex flex-wrap gap-3">
        {value.map((u, i) => (
          <div key={u} className="relative h-20 w-28 overflow-hidden rounded-xl border border-ink/10" data-testid={`${testid}-item-${i}`}>
            <img src={u} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((x) => x !== u))} data-testid={`${testid}-remove-${i}`}
              className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-white/90 text-red-600" aria-label="Remove photo"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={(e) => upload([...e.target.files])} data-testid={`${testid}-file`} />
        <button type="button" disabled={busy || value.length >= 10} onClick={() => ref.current.click()} data-testid={`${testid}-upload`}
          className="grid h-20 w-28 place-items-center rounded-xl border border-dashed border-ink/20 text-xs text-ink/60 hover:border-brand">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <span className="flex flex-col items-center gap-1"><ImagePlus className="h-4 w-4" />Add photos</span>}
        </button>
      </div>
    </div>
  );
};
